const namespace = {
  sidebar: {
    header: {
      title: "Categories",
      backAction: "Back to menu",
      toggle: {
        ariaLabel: "Toggle sidebar",
        ariaLabel_open: "Open sidebar",
        ariaLabel_close: "Close sidebar",
      },
    },
  },
  categoriesToggle: {
    toggleLabel: "Categories",
    backAction: "Back",
  },
  categories: {
    transport: "Transport",
    amenities: "Amenities",
    character: "Character",
    nature: "Nature",
    education: "Education",
    health: "Health",
  },
  scoreComparison: {
    text: "Comparable to the {{name}} average of {{value}}",
    text_higher: "Higher than the {{name}} average of {{value}}",
    text_lower: "Lower than the {{name}} average of {{value}}",
  },
  poiList: {
    subcategoriesTitle: "Select subcategory",
    subcategoriesTitle_transit_friendly: "Select type of transportation",
    subcategoriesTitle_groceries: "Select type of grocery store",
    subcategoriesTitle_restaurants: "Select type of restaurant",
    subcategoriesTitle_wellness: "Select type of amenity",
    searchRadius: "Showing POIs in a {{radius}} {{unit}} radius",
  },
  commute: {
    placeholder: "Search map...",
    cta: "Calculate commute",
    cta_long: "Calculate commute",
    cta_short: "Calculate",
    viewRoute: "View route",
    travelTypes: {
      walking: "Walking",
      driving: "Driving",
      cycling: "Cycling",
    },
    results: {
      noRoute: "No route available.",
      trySuggestion: "Try another query.",
      fastestRoute: "Fastest route",
    },
  },

  // Deprecated with LocalContentDeprecated
  results: {
    none: "Sorry, there are no score results for this search within the specified radius around the selected location",
    limited: "Limited results for this search within a radius of",
  },

  // Deprecate with LocalContentDeprecated
  commuteCalculatorDeprecated: {
    type: {
      pedestrian: "Walking",
      car: "Driving",
    },
    placeholder: "Search map...",
    cta: "Calculate commute",
    ctaShort: "Calculate",
    results: {
      noRoute: "No route available.",
      trySuggestion: "Try another query.",
      fastestRoute: "Fastest route",
    },
  },

  // Deprecate with LocalContentDeprecated
  scores: {
    location: "This Location",
    average: "{{type}} Avg.",
    city: "City",
    neighborhood: "Neighborhood",
  },

  // Deprecate with LocalContentDeprecated
  tabs: {
    commute: "Transport",
    amenities: "Amenities",
    character: "Character",
    nature: "Nature",
    education: "Education",
    wellness: "Wellness",
  },
} as const;

export default namespace;
